export function capitalizeText(text: string): string {
  if (text?.length) {
    return text.toUpperCase();
  } else {
    return "";
  }
}
